import React, { useEffect } from 'react';
import { Modal, Form, Input } from 'antd';
import {
  LinkOutlined,
  LockOutlined,
  UserOutlined,
} from '@ant-design/icons';

const CollectionCreateForm = ({
  visible,
  onCancel,
  onCreate,
  currentSkillUser,
  serverConnection,
}) => {
  const [form] = Form.useForm();

  const name =
    currentSkillUser && currentSkillUser.user_obj
      ? currentSkillUser.user_obj.displayName || currentSkillUser.user_obj.name
      : null;

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onCreate(values);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const modalTitle = serverConnection
    ? 'Jira Server/Data Center Connection'
    : 'Verify your Jira account';

  return (
    <Modal
      visible={visible}
      title={modalTitle}
      okText="Connect"
      onCancel={onCancel}
      onOk={handleOk}
      okButtonProps={{ disabled: false }}
      centered
    >
      <Form form={form} layout="vertical">
        {serverConnection && (
          <Form.Item
            label="Jira Server Url"
            name="url"
            rules={[
              {
                required: true,
                message: 'Please enter valid url!',
                type: 'url',
              },
            ]}
            extra={
              <span
                style={{
                  color:
                    localStorage.getItem('theme') === 'dark'
                      ? 'rgba(255,255,255,0.45)'
                      : undefined,
                }}
              >
                Example: http://jira.troopr.io
              </span>
            }
          >
            <Input
              className={`input-bg ${localStorage.getItem('theme') === 'dark' && 'autofill_dark'
                }`}
              prefix={
                <LinkOutlined
                  style={{
                    color:
                      localStorage.getItem('theme') === 'default'
                        ? 'rgba(0,0,0,.25)'
                        : undefined,
                  }}
                />
              }
            />
          </Form.Item>
        )}

        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Please input Username!' }]}
          initialValue={name}
        >
          <Input
            className={`input-bg ${localStorage.getItem('theme') === 'dark' && 'autofill_dark'
              }`}
            prefix={
              <UserOutlined
                style={{
                  color:
                    localStorage.getItem('theme') === 'default'
                      ? 'rgba(0,0,0,.25)'
                      : undefined,
                }}
              />
            }
          />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your Password!' }]}
        >
          <Input.Password
            className="input-bg"
            prefix={
              <LockOutlined
                style={{
                  color:
                    localStorage.getItem('theme') === 'default'
                      ? 'rgba(0,0,0,.25)'
                      : undefined,
                }}
              />
            }
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CollectionCreateForm;
